  document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.getElementById('mobile-menu-trigger');
    const menu = document.getElementById('mobile-dropdown-menu');
    const body = document.body;

    function toggleMenu() {
      const isOpen = menu.classList.contains('is-open');

      if (isOpen) {
        menu.classList.remove('is-open');
        trigger.classList.remove('is-active');
        body.classList.remove('menu-open');
      } else {
        menu.classList.add('is-open');
        trigger.classList.add('is-active');
        body.classList.add('menu-open');
        const searchBar = document.getElementById('mobile-search-bar');
        if (searchBar) searchBar.classList.remove('is-open');
      }
    }

    if (trigger) trigger.addEventListener('click', toggleMenu);

    const toggles = document.querySelectorAll('.m-menu-toggle');
    toggles.forEach((toggle) => {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        this.classList.toggle('is-active');
        const linkWrapper = this.closest('.m-menu-link-wrapper');
        const submenu = linkWrapper.nextElementSibling;

        if (submenu && submenu.classList.contains('m-submenu')) {
          submenu.classList.toggle('is-visible');
        }
      });
    });

    const mobileHeader = document.querySelector('.mobile-header-container');
    const mobileSearchBar = document.getElementById('mobile-search-bar');
    const mobileSearchInput = mobileSearchBar ? mobileSearchBar.querySelector('.mobile-search-input') : null;

    if (mobileHeader && mobileSearchBar) {
      mobileHeader.addEventListener('click', function(e) {
        const searchBtn = e.target.closest('.js-mobile-search-toggle');
        if (searchBtn) {
          e.preventDefault();
          mobileSearchBar.classList.toggle('is-open');
          
          if (menu.classList.contains('is-open')) toggleMenu();

          if (mobileSearchBar.classList.contains('is-open') && mobileSearchInput) {
            setTimeout(() => mobileSearchInput.focus(), 50);
          }
        }
      });

      document.addEventListener('click', function (e) {
         const searchBtn = e.target.closest('.js-mobile-search-toggle');
         const isClickInsideBar = mobileSearchBar.contains(e.target);
         
         if (!isClickInsideBar && !searchBtn) {
           mobileSearchBar.classList.remove('is-open');
         }
      });
    }
  });
